"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");

var ApplicationStatus =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ApplicationStatus, _DomainObject_1$Domai);

  function ApplicationStatus() {
    _classCallCheck(this, ApplicationStatus);

    return _possibleConstructorReturn(this, _getPrototypeOf(ApplicationStatus).apply(this, arguments));
  }

  return ApplicationStatus;
}(DomainObject_1.DomainObject);

exports.ApplicationStatus = ApplicationStatus;